export const SET_IS_CART_OPEN = "cart/SET_IS_CART_OPEN";
export const SET_CART_ITEMS = "cart/SET_CART_ITEMS";
export const SET_CART_COUNT = "cart/SET_CART_COUNT";
export const SET_CART_TOTAL = "cart/SET_CART_TOTAL";
